import config from 'app/config';
import request from 'superagent';

export default (key, password) =>
  new Promise((resolve, reject) => {
    const apiHost = config.get('AUTH_HOST');
    const endpoint = `${apiHost}/v1/password-reset/${key}`;

    request
      .post(endpoint)
      .send({ password })
      .end((err, res) => {
        if (err) {
          return reject(err);
        }
        return resolve(res.body);
      });
  });
